/**
 * Web component: plans-download (plans-download)
 * -----------------------------------------------------------------------------
 * CTA Trigger to open download popup.
 *
 */
/* eslint no-unused-vars: ['error', { 'argsIgnorePattern': 'component' }] */
import './plans-download.scss';

import { vueReady } from '~/core/runners';

/**
 * DOM selectors.
 */
const selectors = {
  button: '.plans-download__button',
};

/**
 * Create new <plans-download> custom element.
 */
class PlansDownload extends HTMLElement {
  /**
   * Component lifecycle - before mount.
   */
  constructor() {
    super();
    this.$data = {};
  }

  data(component) {
    return {
      selectors: {
        button: component.querySelector(selectors.button),
      },
    };
  }

  /**
   * Component lifecycle - mounted.
   */
  connectedCallback() {
    this.$data = this.data(this);

    this.$data.selectors.button.addEventListener('click', () => {
      cnvs.EventBus.emit('overlay:open', {
        ignoreDismissed: true,
        namespace: `plansPopupOverlay--${this.dataset.sectionId}`,
      });
    });
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('plans-download')) {
    return;
  }

  customElements.define('plans-download', PlansDownload);
});
